import { useState } from "react";
import styled from "styled-components";
import SectionLable from "../SectionLable/SectionLable";
import AnimationFadeOut from "../Animation/AnimationFadeOut";
import { getYouTubeEmbedUrl } from "../../utils/youtube";


const ProjectHeaderBackground = styled.div`
    width: 100%;
    max-width: 1920px;
    margin-left: auto;
    margin-right: auto;
    background-color: #1b1b1b;
    padding-top: 50px;
    padding-bottom: 90px;

    @media (max-width: 767px) {
        padding-top: 40px;
        padding-bottom: 50px;
    }      
`

const ProjectVideoStyled = styled.video`
    width: 100%;
    max-width: 1600px;
    
    /* видео по центру */
    display: block;
    margin-left: auto;
    margin-right: auto;
    
    margin-top: 80px;
    object-fit: cover;

    @media (max-width: 767px) {
        margin-top: 40px;
    }  
`

const ProjectVideoPoster = styled.img`
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    max-width: 1600px;
    height: auto;
    margin-top: 80px;

    @media (max-width: 767px) {
        margin-top: 40px;
    }
`

/* YouTube-плеер: до клика - постер проекта с кнопкой play, после - iframe с autoplay */
const ProjectYouTubeWrapper = styled.div`
    position: relative;
    width: 100%;
    max-width: 1600px;
    aspect-ratio: 16 / 9;
    margin: 80px auto 0;

    @media (max-width: 767px) {
        margin-top: 40px;
    }
`

const ProjectYouTubePoster = styled.img`
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    cursor: pointer;
`

const ProjectYouTubeIframe = styled.iframe`
    display: block;
    width: 100%;
    height: 100%;
    border: 0;
`

const PlayButton = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90px;
    height: 90px;
    border-radius: 50%;
    background-color: rgba(252, 100, 53, 0.9);
    cursor: pointer;
    transition: .3s ease-in-out;

    &::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 55%;
        transform: translate(-50%, -50%);
        border-style: solid;
        border-width: 17px 0 17px 28px;
        border-color: transparent transparent transparent #f9f9f9;
    }

    ${ProjectYouTubeWrapper}:hover & {
        transform: translate(-50%, -50%) scale(1.1);
    }

    @media (max-width: 767px) {
        width: 60px;
        height: 60px;

        &::after {
            border-width: 11px 0 11px 19px;
        }
    }
`

const ProjectHeader = (props) => {
    const [videoStarted, setVideoStarted] = useState(false);
    const embedUrl = getYouTubeEmbedUrl(props.projectItem.video_path);

    return (
        <ProjectHeaderBackground>
            <SectionLable textColor="#fc6435">
                {props.projectItem.title}
            </SectionLable>

            {/* Если есть видео, то показываем, если нет, только заглушку.
                Ссылка на YouTube - постер с кнопкой play, по клику iframe-плеер;
                иначе считаем, что это путь к mp4-файлу */}
            {props.projectItem.video_path ?
                (embedUrl ?
                    <ProjectYouTubeWrapper onClick={() => setVideoStarted(true)}>
                        {videoStarted ?
                            <ProjectYouTubeIframe
                                src={embedUrl + '?autoplay=1'}
                                title={props.projectItem.title?.replace('<br>', ' ')}
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            />
                            :
                            <>
                                <ProjectYouTubePoster src={props.projectItem.video_poster} />
                                <PlayButton />
                            </>
                        }
                    </ProjectYouTubeWrapper>
                    :
                    <ProjectVideoStyled controls loop poster={props.projectItem.video_poster}>
                        <source src={props.projectItem.video_path} type="video/mp4" />
                    </ProjectVideoStyled>
                )
                :
                <AnimationFadeOut>
                    <ProjectVideoPoster src={props.projectItem.video_poster} />
                </AnimationFadeOut>
            }
        </ProjectHeaderBackground>
     );
}
 
export default ProjectHeader;